/**
 * Script component for howlding avatar and TTS scripts
 */
import WideoObject from "../WideoObject";
import { ScriptComponentDef } from '../model/WideoDef';
import WideoContext from '../WideoContext';
import AbstractComponent from './AbstractComponent';
import { v4 as uuid } from 'uuid';
import Attributes from "../Attributes";

export default class ScriptComponent extends AbstractComponent {
  protected _script: string;
  protected _replicaId: string;
  protected _backgroundUrl: string;
  protected _backgroundSrcUrl: string;
  protected _properties: string;

  constructor(context: WideoContext, owner: WideoObject, def: ScriptComponentDef) {
    super(false);
    this.priority = 2500; // Set higher than AnimationComponent
    this._owner = owner;
    this._class = def.class;
    this._context = context;
    this._id = def.id || uuid(); // Use provided ID or generate a new one
    this._script = def.script;
    this._replicaId = def.replicaId;
    this._backgroundUrl = def.backgroundUrl || '';
    this._backgroundSrcUrl = def.backgroundSrcUrl || '';
    this._properties = def.properties || '';
  }

  public serialize(): ScriptComponentDef {
    const serialized: ScriptComponentDef = {
      id: this._id,
      class: this._class,
      script: this._script,
      replicaId: this._replicaId
    };

    if (this._backgroundUrl) {
      serialized.backgroundUrl = this._backgroundUrl;
    }
    if (this._backgroundSrcUrl) {
      serialized.backgroundSrcUrl = this._backgroundSrcUrl;
    }
    if (this._properties) {
      serialized.properties = this._properties;
    }

    return serialized;
  }

  public setScript(script: string): void {
    this._script = script;
  }

  public getScript(): string {
    return this._script;
  }

  public setReplicaId(replicaId: string): void {
    this._replicaId = replicaId;
  }

  public getReplicaId(): string {
    return this._replicaId;
  }

  public setBackgroundUrl(backgroundUrl: string): void {
    this._backgroundUrl = backgroundUrl;
  }

  public getBackgroundUrl(): string {
    return this._backgroundUrl;
  }

  public setbackgroundSrcUrl(backgroundSrcUrl: string): void {
    this._backgroundSrcUrl = backgroundSrcUrl;
  }

  public getbackgroundSrcUrl(): string {
    return this._backgroundSrcUrl;
  }

  public setProperties(properties: string): void {
    this._properties = properties;
  }

  public getProperties(): string {
    return this._properties;
  }

  public update(deltaTime: number, playing?: boolean): Attributes {
    return null;
  }

}